/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ActionUpdateRequest,
  HTTPValidationError,
  PlanUpdateRequest,
  ProjectHubResponse,
} from './platformapi.schemas';

import postActionUpdateMutator from '../custom-axios-instance';
import postPlanUpdateMutator from '../custom-axios-instance';
import getProjectHubDataByMatchGroupMutator from '../custom-axios-instance';

/**
 * Posts a project work update with provided project and the auth session user id
 * @summary Post Action Update
 */
export const postActionUpdate = (
  actionUpdateRequest: ActionUpdateRequest,
  signal?: AbortSignal,
) => {
  return postActionUpdateMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/project-hub/action-update`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: actionUpdateRequest,
    signal,
  });
};

export const getPostActionUpdateMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postActionUpdate>>,
    TError,
    { data: ActionUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postActionUpdate>>,
  TError,
  { data: ActionUpdateRequest },
  TContext
> => {
  const mutationKey = ['postActionUpdate'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postActionUpdate>>,
    { data: ActionUpdateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postActionUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostActionUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postActionUpdate>>
>;
export type PostActionUpdateMutationBody = ActionUpdateRequest;
export type PostActionUpdateMutationError = HTTPValidationError;

/**
 * @summary Post Action Update
 */
export const usePostActionUpdate = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postActionUpdate>>,
      TError,
      { data: ActionUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postActionUpdate>>,
  TError,
  { data: ActionUpdateRequest },
  TContext
> => {
  const mutationOptions = getPostActionUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Posts a project update with provided project and the auth session user id
 * @summary Post Plan Update
 */
export const postPlanUpdate = (planUpdateRequest: PlanUpdateRequest, signal?: AbortSignal) => {
  return postPlanUpdateMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/project-hub/plan-update`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: planUpdateRequest,
    signal,
  });
};

export const getPostPlanUpdateMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPlanUpdate>>,
    TError,
    { data: PlanUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPlanUpdate>>,
  TError,
  { data: PlanUpdateRequest },
  TContext
> => {
  const mutationKey = ['postPlanUpdate'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPlanUpdate>>,
    { data: PlanUpdateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postPlanUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPlanUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof postPlanUpdate>>>;
export type PostPlanUpdateMutationBody = PlanUpdateRequest;
export type PostPlanUpdateMutationError = HTTPValidationError;

/**
 * @summary Post Plan Update
 */
export const usePostPlanUpdate = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postPlanUpdate>>,
      TError,
      { data: PlanUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postPlanUpdate>>,
  TError,
  { data: PlanUpdateRequest },
  TContext
> => {
  const mutationOptions = getPostPlanUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Fetches all data required to render project hub for a specific match group
 * @summary Get Project Hub Data By Match Group
 */
export const getProjectHubDataByMatchGroup = (matchGroupId: number, signal?: AbortSignal) => {
  return getProjectHubDataByMatchGroupMutator<ProjectHubResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/project-hub/${matchGroupId}`,
    method: 'GET',
    signal,
  });
};

export const getGetProjectHubDataByMatchGroupQueryKey = (matchGroupId?: number) => {
  return [`${import.meta.env['VITE_API_HOST']}/project-hub/${matchGroupId}`] as const;
};

export const getGetProjectHubDataByMatchGroupQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectHubDataByMatchGroup>>,
  TError = HTTPValidationError,
>(
  matchGroupId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectHubDataByMatchGroup>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectHubDataByMatchGroupQueryKey(matchGroupId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectHubDataByMatchGroup>>> = ({
    signal,
  }) => getProjectHubDataByMatchGroup(matchGroupId, signal);

  return { queryKey, queryFn, enabled: !!matchGroupId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectHubDataByMatchGroup>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectHubDataByMatchGroupQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectHubDataByMatchGroup>>
>;
export type GetProjectHubDataByMatchGroupQueryError = HTTPValidationError;

export function useGetProjectHubDataByMatchGroup<
  TData = Awaited<ReturnType<typeof getProjectHubDataByMatchGroup>>,
  TError = HTTPValidationError,
>(
  matchGroupId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectHubDataByMatchGroup>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectHubDataByMatchGroup>>,
          TError,
          Awaited<ReturnType<typeof getProjectHubDataByMatchGroup>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectHubDataByMatchGroup<
  TData = Awaited<ReturnType<typeof getProjectHubDataByMatchGroup>>,
  TError = HTTPValidationError,
>(
  matchGroupId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectHubDataByMatchGroup>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectHubDataByMatchGroup>>,
          TError,
          Awaited<ReturnType<typeof getProjectHubDataByMatchGroup>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectHubDataByMatchGroup<
  TData = Awaited<ReturnType<typeof getProjectHubDataByMatchGroup>>,
  TError = HTTPValidationError,
>(
  matchGroupId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectHubDataByMatchGroup>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Project Hub Data By Match Group
 */

export function useGetProjectHubDataByMatchGroup<
  TData = Awaited<ReturnType<typeof getProjectHubDataByMatchGroup>>,
  TError = HTTPValidationError,
>(
  matchGroupId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectHubDataByMatchGroup>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectHubDataByMatchGroupQueryOptions(matchGroupId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
